export default __webpack_public_path__ + "static/1223-6d5c1d627b4beb9353ba410fe5ffa27a.gif";